import { Anchor, Icon } from "client/Components";
import { setTrackingId } from "client/Misc/utils";
import { ReactElement } from "react";
import { useObservableSettingsStore } from "client_legacy/ndaw/observableSettings";
import styles from "./MenuItem/MenuItem.module.less";
import { WorkspaceHeaderStyle } from "client_legacy/ndaw/workspaceAbilitiesStatusProvider";
import classNames from "classnames";

export type NewFeaturesMenuItemProps = {
	headerStyle: WorkspaceHeaderStyle;
};

export const NewFeaturesMenuItem = (props: NewFeaturesMenuItemProps): ReactElement => {
	const {
		headerStyle
	} = props;

	const isEnabled: boolean = useObservableSettingsStore(x => x.isNewFeatureDialogEnabled);

	return (
		<li
			{...setTrackingId("new-features")}
			className={classNames(
				styles.root,
				{[styles.root_coloredHeader]: headerStyle === WorkspaceHeaderStyle.ColoredBackground}
			)}
		>
			<Anchor
				trackingId="link"
				className={styles.link}
				style={{ "display": isEnabled ? undefined : "none"}}
			>
				<div className={styles.container}>
					<Icon value="gift" />
				</div>
			</Anchor>
		</li>
	);
};
NewFeaturesMenuItem.displayName = "NewFeaturesMenuItem";